export class RecordingChunkUploadError extends Error {
  readonly status: number;

  constructor(status: number, body: string) {
    super(`Recording chunk upload failed (${status}): ${body}`);
    this.name = 'RecordingChunkUploadError';
    this.status = status;
  }
}

export const isRetryableChunkUploadStatus = (status: number) =>
  status === 401 || status === 408 || status === 409 || status === 429 || status >= 500;
